'use strict';

// 総合pt推移グラフの表示人数フィルタ（21人以上のリーグ用）。
// packはhead読み込みのため turbolinks:load 直後にはグラフがまだ生成されていない可能性がある。
// そのため graphs/_league_result.html.erb がチャート生成後に発火する 'league:graph-ready' を購読して初期化する。
//
// Chart.js側の実表示は2つの独立した真偽値配列のORで決まる:
//   filteredOut[i] : プリセット/チーム選択/モーダル選択による除外（凡例からも消す＝hidden属性）
//   legendHidden[i]: 凡例クリック/チームロゴクリックによる一時非表示（凡例には残す＝opacity低下のみ）
// 凡例クリックの既存ハンドラ（_league_result.html.erb側）はmeta.hiddenを直接操作するため、
// apply()の先頭で「filteredOutでないdatasetのmeta.hidden」をlegendHiddenへ吸い上げてから
// filteredOutを再計算し、最後に両者のORをmeta.hiddenへ書き戻す。
//
// 状態はチャートIDをキーに保持し、'league:graph-ready'のたびに作り直す（ページリロードでリセットする仕様のため）。
var leagueGraphFilterState = {};

// data-i18n のJSONを読む。壊れている場合は空オブジェクトにフォールバックする
function leagueGraphFilterParseI18n(filterEl) {
  try {
    return JSON.parse(filterEl.dataset.i18n || '{}');
  } catch (e) {
    console.error('league_graph_filter: data-i18nのJSON解析に失敗しました', e);
    return {};
  }
}

// 現在の preset / team選択 / モーダル選択からfilteredOutを再計算する
function leagueGraphFilterRecompute(state) {
  var datasets = state.chart.data.datasets;

  if (state.visibleIds) {
    datasets.forEach(function (ds, i) {
      state.filteredOut[i] = !state.visibleIds.has(Number(ds.playerId));
    });
    return;
  }

  if (state.teamId !== null) {
    datasets.forEach(function (ds, i) {
      state.filteredOut[i] = Number(ds.teamId) !== state.teamId;
    });
    return;
  }

  datasets.forEach(function (ds, i) {
    var isMine = state.myPlayerId !== null && Number(ds.playerId) === state.myPlayerId;
    if (state.preset === 'mine') {
      state.filteredOut[i] = !isMine;
    } else if (state.preset === 'all') {
      state.filteredOut[i] = false;
    } else {
      // 既定の'top': 上位defaultCount位 または 自分自身は表示
      state.filteredOut[i] = !((Number(ds.rank) <= state.defaultCount) || isMine);
    }
  });
}

// 凡例DOM（各アイテムのhidden属性・opacity、チーム行の全体非表示）を更新する
function leagueGraphFilterUpdateLegendDom(state) {
  var legendRoot = document.getElementById(state.legendId);
  if (!legendRoot) return;

  var items = legendRoot.querySelectorAll('.team-legend-item[data-index]');
  items.forEach(function (item) {
    var idx = parseInt(item.dataset.index, 10);
    item.hidden = !!state.filteredOut[idx];
    item.style.opacity = state.legendHidden[idx] ? '0.3' : '1';
  });

  // チーム凡例の行は、行内の全アイテムがfilteredOutなら行ごと隠す
  var rows = legendRoot.querySelectorAll('.graph-legend-team-row');
  rows.forEach(function (row) {
    var rowItems = row.querySelectorAll('.team-legend-item[data-index]');
    if (rowItems.length === 0) return;
    var allFilteredOut = Array.prototype.every.call(rowItems, function (item) {
      return item.hidden;
    });
    row.hidden = allFilteredOut;
  });
}

// ラベル右横の「(N/M)」テキストを更新する
function leagueGraphFilterUpdateCount(state) {
  var $count = $(state.filterEl).find('.js-graph-visible-count');
  if ($count.length === 0) return;

  var total = state.chart.data.datasets.length;
  var visible = state.filteredOut.filter(function (hidden) { return !hidden; }).length;
  var text = window.Janreco.pluralize(state.i18n.visibleCount, total).replace('%{visible}', visible);
  $count.text(text);
}

// フィルタ状態をChart.js/凡例DOM/カウント表示へ反映する
function leagueGraphFilterApply(chartId) {
  var state = leagueGraphFilterState[chartId];
  if (!state) return;
  var datasets = state.chart.data.datasets;

  // 1) 凡例クリック/チームロゴクリックによる一時非表示を吸い上げる（filteredOutなdatasetは対象外）
  datasets.forEach(function (ds, i) {
    if (!state.filteredOut[i]) {
      state.legendHidden[i] = state.chart.getDatasetMeta(i).hidden === true;
    }
  });

  // 2) プリセット/チーム選択/モーダル選択からfilteredOutを再計算する
  leagueGraphFilterRecompute(state);

  // 3) Chart.jsの実表示へ反映する（両状態のOR）
  datasets.forEach(function (ds, i) {
    state.chart.getDatasetMeta(i).hidden = !!(state.filteredOut[i] || state.legendHidden[i]);
  });

  // 4)-5) 凡例DOMを更新する
  leagueGraphFilterUpdateLegendDom(state);

  // 6) 表示人数テキストを更新する
  leagueGraphFilterUpdateCount(state);

  // 7) 表示中のデータセットだけでY軸の範囲を引き直す
  window.JanrecoUtils.rescaleLeagueChartY(state.chart, chartId);

  // 8) チャートを再描画する
  state.chart.update();
}

// チャート生成完了の通知を受けて、フィルタの状態を初期化する
document.addEventListener('league:graph-ready', function (e) {
  var detail = e.detail || {};
  var chartId = detail.chartId;
  var chart = detail.chart;
  var legendId = detail.legendId;
  if (!chartId || !chart) return;

  var filterEl = document.querySelector('.league-graph-filter[data-chart-id="' + chartId + '"]');
  if (!filterEl) return; // 20人以下のリーグはフィルタバー自体が存在しない

  var datasets = chart.data.datasets || [];

  leagueGraphFilterState[chartId] = {
    chart: chart,
    legendId: legendId,
    filterEl: filterEl,
    // サーバー側で既に「上位defaultCount位 or 自分」がhidden:trueとして計算済みのため、
    // 初期状態はそれをそのまま引き継ぐ（初期プリセットは'top'固定）
    filteredOut: datasets.map(function (ds) { return ds.hidden === true; }),
    legendHidden: datasets.map(function () { return false; }),
    preset: 'top',
    teamId: null,
    visibleIds: null,
    defaultCount: Number(filterEl.dataset.defaultCount) || 0,
    myPlayerId: filterEl.dataset.myPlayerId ? Number(filterEl.dataset.myPlayerId) : null,
    i18n: leagueGraphFilterParseI18n(filterEl),
    modal: null
  };

  leagueGraphFilterUpdateLegendDom(leagueGraphFilterState[chartId]);
  leagueGraphFilterUpdateCount(leagueGraphFilterState[chartId]);
});

// グラフモード（対局別/日別）切替後、datasetsの並びは変わらないため同じ状態のまま再適用する
document.addEventListener('league:graph-mode-changed', function (e) {
  var detail = e.detail || {};
  var state = leagueGraphFilterState[detail.chartId];
  if (!state) return;
  if (detail.chart) state.chart = detail.chart;
  leagueGraphFilterApply(detail.chartId);
});

// プリセットボタン（上位N人/自分/全員）
$(document).on('click', '.js-graph-filter-preset', function () {
  var $btn = $(this);
  var $filter = $btn.closest('.league-graph-filter');
  var chartId = $filter.data('chart-id');
  var state = leagueGraphFilterState[chartId];
  if (!state) return;

  state.preset = $btn.data('preset');
  state.visibleIds = null;
  state.teamId = null;
  $filter.find('.js-graph-filter-team').val('');
  $filter.find('.js-graph-filter-preset').removeClass('is-active');
  $btn.addClass('is-active');

  leagueGraphFilterApply(chartId);
});

// チーム別セレクト（チーム戦のみ表示）
$(document).on('change', '.js-graph-filter-team', function () {
  var $select = $(this);
  var $filter = $select.closest('.league-graph-filter');
  var chartId = $filter.data('chart-id');
  var state = leagueGraphFilterState[chartId];
  if (!state) return;

  var value = $select.val();
  state.visibleIds = null;

  if (value === '') {
    // チーム選択解除: 直前のプリセットに戻す
    state.teamId = null;
    $filter.find('.js-graph-filter-preset').removeClass('is-active')
      .filter('[data-preset="' + state.preset + '"]').addClass('is-active');
  } else {
    state.teamId = Number(value);
    $filter.find('.js-graph-filter-preset').removeClass('is-active');
  }

  leagueGraphFilterApply(chartId);
});

// 「プレイヤーを選択」ボタン: 自由選択モードのモーダルを開く
$(document).on('click', '.js-graph-filter-select', function () {
  var $btn = $(this);
  var $filter = $btn.closest('.league-graph-filter');
  var chartId = $filter.data('chart-id');
  var state = leagueGraphFilterState[chartId];
  if (!state || !window.PlayerSelectModal) return;

  if (!state.modal) {
    state.modal = new window.PlayerSelectModal();
  }

  var datasets = state.chart.data.datasets;
  var items = datasets.map(function (ds) {
    return { id: ds.playerId, name: ds.label };
  });
  var checkedIds = [];
  datasets.forEach(function (ds, i) {
    if (!state.filteredOut[i]) checkedIds.push(ds.playerId);
  });

  state.modal.open({
    items: items,
    limit: items.length,
    title: state.i18n.selectPlayers,
    selectionMode: 'free',
    minSelected: 1,
    checkedIds: checkedIds,
    loadingOnConfirm: false,
    onConfirm: function (selectedIds) {
      state.visibleIds = new Set(selectedIds.map(Number));
      state.teamId = null;
      $filter.find('.js-graph-filter-team').val('');
      $filter.find('.js-graph-filter-preset').removeClass('is-active');
      leagueGraphFilterApply(chartId);
      state.modal.close();
    }
  });
});
